"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAddinCollection_1 = require("./getAddinCollection");
var getDisplayNameFromKey_1 = require("./getDisplayNameFromKey");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var owa_addins_core_1 = require("owa-addins-core");
function addItemToSurfaceCollection(surfaceItems, item, isEndAligned) {
    if (isEndAligned) {
        surfaceItems.unshift(item);
    }
    else {
        surfaceItems.push(item);
    }
}
function tryAddDivider(overflowItems, dividerKey) {
    var itemLength = overflowItems.length;
    if (itemLength > 0 && overflowItems[itemLength - 1].displayName != getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME) {
        overflowItems.push({
            key: "addinDivider_" + dividerKey,
            displayName: getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME,
            itemType: ContextualMenu_1.ContextualMenuItemType.Divider,
            onClick: null,
        });
    }
}
function populateCommandBarWithAddins(extMode, hostId, surfaceAddinKeys, surfaceItems, overflowItems, isEndAligned, shouldPopulateSurface, dividerKey, className) {
    var installedAddins;
    var addinCollection = getAddinCollection_1.default(extMode);
    installedAddins = addinCollection ? addinCollection.sectionProps.items : [];
    var hostItemIndex = extMode == owa_addins_core_1.ExtensibilityModeEnum.MessageRead
        ? owa_addins_core_1.getReadHostItemIndex(hostId)
        : owa_addins_core_1.getComposeHostItemIndex(hostId);
    var shouldAddFirstDivider = true;
    installedAddins.forEach(function (addin) {
        owa_addins_core_1.convertToIContextualMenuItem(hostItemIndex, addin);
        var commandBarItem = addin;
        commandBarItem.iconOnly = true;
        if (className) {
            commandBarItem.className = className;
        }
        // Check if the user has this addin in their surface addins.
        if (surfaceAddinKeys.indexOf(addin.key) >= 0 && shouldPopulateSurface) {
            // If they do, add it to the surface items.
            addItemToSurfaceCollection(surfaceItems, commandBarItem, isEndAligned);
        }
        else {
            // If they don't, push it to the overflow, but first add a divider to separate addins from actions if needed.
            if (shouldAddFirstDivider) {
                tryAddDivider(overflowItems, dividerKey++);
                shouldAddFirstDivider = false;
            }
            overflowItems.push(commandBarItem);
        }
    });
}
exports.default = populateCommandBarWithAddins;
//# sourceMappingURL=populateCommandBarWithAddins.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/utils/populateCommandBarWithAddins.js
// module id = 3093
// module chunks = 2 3 4